const MEDIA_BASE_URL = 'https://media.yocoolmate.com';

export function resolveClipUrl(path: string | null): string | null {
  if (!path) {
    return null;
  }
  return `${MEDIA_BASE_URL}/${path}`;
}
